import React, {useState, useRef, useEffect} from "react";
import Icon from "../../favourites/icons/Icon";
import isLoggedIn from "../../../components/isLoggedIn";
import axios from "axios";
import Color from "../../icons/Color";
import WarmthIndicator from "../../warmth-indicator/WarmthIndicator";

const ProductTile = (props) => {

  const {
    product
  } = props;


  const [img, setImg] = useState(product.image);
  const [link, setLink] = useState(product.link);

  const bg = useRef();

  const updateToVariation = (variation) => {
    setImg(variation?.image);
    setLink(variation?.link);
  };

  const handleFavoriteClick = (event) => {
    // Prevent event propagation to parent elements
    event.stopPropagation();
    // Handle favorite icon click logic here
    // For example: toggle favorite status, make API calls, etc.
  };

  const resetToDefaults = () => {
    let defaultImg = product.image;
    for (const variation of product.variations) {
      if (variation.selected) {
        defaultImg = variation.image;
      }
    }
    setImg(defaultImg);
    setLink(product.link);
  };

  const updateToModelShot = () => {
    if (product.model_image) {
      setImg(product.model_image);
    }
  };

  const mouseEnter = () => {
    const bgElement = bg.current;
    if (bgElement) {
      const anchor = bgElement.parentNode;
      const ul = anchor.querySelector('.card-product__variations__holder');
      if (ul) {
        const rect = anchor.getBoundingClientRect();
        const ulRect = ul.getBoundingClientRect();
        const height = rect.height + (ulRect.height - 72);
        bgElement.style.height = height + 'px';
      }
    }
  };

  const mouseLeave = () => {
    const bgElement = bg.current;
    if (bgElement) {
      bgElement.style.removeProperty('height');
    }
  };

  useEffect(() => {
    resetToDefaults();
  }, [])

  const selectColor = (color) => {
    const variation = getVariationById(color.variation_id);
    updateToVariation(variation);
  };


  const getVariationById = (id) => {
    const product = props.product;
    const variations = product.variations;
    for (const key of Object.keys(variations)) {
      const variation = variations[key];
      if (variation.id === id) {
        return variation;
      }
    }
    return null;
  };


  const loggedIn = isLoggedIn();

  return (
    <div className="card-product"
         onMouseEnter={updateToModelShot}
         onMouseLeave={resetToDefaults}>

      <div className="card-product-align" onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
        <div className="card-product__bg" ref={bg}></div>
        <div className="card-product__inner">
          {!!product.custom_1010 && <div className='card-product__new-color-tag'>
            <span >{product.custom_1010}</span>
          </div>}

          <a href={link} className="card-product__image-wrapper">
            <div className="card-product__image-align">
              <div className="card-product__image card-product__image-default"
                   style={{backgroundImage: 'url("' + img + '")'}}>
              </div>
            </div>
          </a>
          <div className="card-product__content">
            <a href={link}>{!!product.custom_1013 &&
              <p className="card-product__material">{product.custom_1013}</p>}</a>
            <a href={link}><h5 className="card-product__title">{product.title}</h5></a>
            <span className="card-product__favorite" onClick={handleFavoriteClick}>
                            <Icon product={product.id} lock={props.lockShare}/>
                        </span>
            <a href={link}>{!!product.style &&
              <p className="card-product__type">Style <strong>{product.style}</strong></p>}</a>
              {product.custom_1004 > 0 && <WarmthIndicator indicator_value ={product.custom_1004} />}
            <a href={link}>{!!product.custom_1006 && <p className="card-product__type">{product.custom_1006}</p>}</a>
            <a href={link}>
              {(!!loggedIn || product.is_au_site) && (
                <p className="card-product__price">{product.price}</p>
              )}
            </a>
            <a href={link} class="mobile-hide">
              {product.variations.length > 0 &&
                <div className="card-product__variations__holder card-product__color-section">
                  <div className="card-product__variations__inner">
                    <ul className="card-product__variations">
                      {product.variations.map((variation) => (
                        <li className="card-product__variations__item"
                            key={'v' + variation.id}
                            onMouseEnter={() => updateToVariation(variation)}
                            onMouseLeave={resetToDefaults}
                        >
                          <div className="card-product__variations__image"
                               style={{backgroundImage: 'url("' + variation.image + '")'}}>
                          </div>
                        </li>
                      ))}
                    </ul>
                    {product.variations.length > 5 && <p className="card-product__more-colors">View more colours</p>}
                  </div>
                </div>
              }
            </a>
            <div class="desktop-hide">
              {product.colors.length > 0 &&
                <div className="card-product__variations__holder card-product__color-section">
                  <div className="card-product__variations__inner">
                    <ul className="card-product__variations">
                      {product.colors.map((color) => (
                        <li className="card-product__variations__item"
                            key={'v' + color.id}
                            onMouseEnter={() => selectColor(color)}
                            onMouseLeave={() =>selectColor(color)}
                        >
                          <div className="card-product__variations__color"
                               style={{
                                 borderColor: '#707070',
                                 backgroundColor: `#${color.color}`,
                                 backgroundImage: color.color_icon ? `url("${color.color_icon}")` : null,
                               }}>
                          </div>
                        </li>
                      ))}
                      {product.colors.length > 4 &&
                        <p className="card-product__more-colors">+{product.colors.length - 4}</p>}
                    </ul>

                  </div>
                </div>
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTile;
